import CompatsMessageFeedback from '../../../../components/compats-widget/message-feedback';
import headCompats from './head.compats';

export default headCompats(CompatsMessageFeedback);
